import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { Salesunit } from './salesunit.model';
import { SalesunitService } from './salesunit.service';
@Injectable()
export class SalesunitPopupService {
    private isOpen = false;
    constructor(
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private salesunitService: SalesunitService

    ) {}

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.salesunitService.find(id).subscribe((salesunit) => {
                salesunit.winterStart = this.datePipe
                    .transform(salesunit.winterStart, 'yyyy-MM-ddThh:mm');
                salesunit.winterEnd = this.datePipe
                    .transform(salesunit.winterEnd, 'yyyy-MM-ddThh:mm');
                salesunit.updated = this.datePipe
                    .transform(salesunit.updated, 'yyyy-MM-ddThh:mm');
                salesunit.created = this.datePipe
                    .transform(salesunit.created, 'yyyy-MM-ddThh:mm');
                this.salesunitModalRef(component, salesunit);
            });
        } else {
            return this.salesunitModalRef(component, new Salesunit());
        }
    }

    salesunitModalRef(component: Component, salesunit: Salesunit): NgbModalRef {
        const modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.salesunit = salesunit;
        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/salesunit/salesunit-popup.service.ts